import { isEmpty } from "ramda";
import { Error } from "../../store";
import Box from "@mui/material/Box";
import { Alert, AlertTitle } from "@mui/lab";
import React from "react";
import { isJson } from "../../repo/api";

interface Props {
  serverError: any;
}

export default function ServerAlert({ serverError }: Props): JSX.Element {
  let error;
  if (!isEmpty(serverError)) {
    if (isJson(serverError)) {
      error = JSON.parse(serverError) as Error[];
    } else {
      error = [
        {
          code: "Runtime",
          title: "Error",
          detail: serverError,
        },
      ] as Error[];
    }
  }
  return (
    <>
      {error && (
        <Box p={2}>
          <Alert severity="error">
            <AlertTitle>{error && error[0]?.title}</AlertTitle>
            {error && error[0]?.detail}
          </Alert>
        </Box>
      )}
    </>
  );
}
